import { render } from "./CategoriesMobile.vue?vue&type=template&id=51b69f61"
import script from "./CategoriesMobile.vue?vue&type=script&lang=js"
export * from "./CategoriesMobile.vue?vue&type=script&lang=js"

import "./CategoriesMobile.vue?vue&type=style&index=0&id=51b69f61&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__